import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { observer } from 'mobx-react-lite';
import globalSettingsStores from '../../../../../stores/settings-stores';
import globalPaymentServices from '../../../../../stores/global-payment-services';
import { SettingsCheckStatusPaymentServiceEntity } from '../../../../../api/types/settings/check-status-payment-service/check-status-payment-service';
import { DialogAddCheckPaymentService } from './compoenents/dialog-add-check-payment-service';
import { deleteCheckPaymentServiceOperation } from './operations/delete-check-payment-service-operation';
import dateFormat from '../../../../../utils/date-format';
import { CheckStatusType } from '../../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';

const checkStatusLabels: Record<CheckStatusType, string> = {
  [CheckStatusType.PENDING]: 'ממתין',
  [CheckStatusType.DEPOSITED]: 'הופקד',
  [CheckStatusType.CLEARED]: 'סולק',
  [CheckStatusType.BOUNCED]: 'חזר',
  [CheckStatusType.CANCELLED]: 'בוטל',
  [CheckStatusType.EXPIRED]: 'פג תוקף',
};

export const ServicesSettingsCheckPayment = observer(() => {
  const [isLoading, setIsLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [deleteCheckId, setDeleteCheckId] = useState<number | null>(null);

  useEffect(() => {
    // Fetch payment services when component mounts
    globalPaymentServices.fetchPaymentService();
  }, []);

  const dialogHide = () => {
    setShowDialog(false);
  };

  const dialogDisplay = () => {
    setShowDialog(true);
  };

  const handleDeleteCheckPayment = async (checkId: number) => {
    await deleteCheckPaymentServiceOperation(checkId, setDeleteCheckId);
  };

  // Create enriched data by joining with payment services
  const enrichedCheckPaymentData = globalSettingsStores.checkPaymentStatus.map(
    (checkItem) => {
      const paymentService = globalPaymentServices.services.find(
        (service) => service.id === checkItem.paymentServiceId,
      );

      return {
        ...checkItem,
        paymentServiceName: paymentService?.paymentServiceName || 'לא נמצא',
        price: paymentService?.versions[0]?.price || 0,
        createdByName: paymentService?.createdByName || '',
        createdAt: paymentService?.createdAt || checkItem.createdAt,
      };
    },
  );

  return (
    <div>
      <Button
        style={{ height: '30px' }}
        label={'הוספה'}
        onClick={dialogDisplay}
      />
      <div style={{ height: '8px' }} />
      <DataTable
        value={enrichedCheckPaymentData}
        loading={isLoading}
        rows={10}
        emptyMessage={<div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>}
        className="p-datatable-striped"
      >
        <Column
          style={{ textAlign: 'right' }}
          field="paymentServiceName"
          header="שם שרות"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="price"
          header="מחיר"
          sortable
          body={(rowData) => <div>₪{rowData.price}</div>}
        />
        <Column
          style={{ textAlign: 'right' }}
          field="checkStatus"
          header="יחוייב עבור סטטוס"
          sortable
          body={(rowData: SettingsCheckStatusPaymentServiceEntity) => (
            <div>{checkStatusLabels[rowData.checkStatus]}</div>
          )}
        />
        <Column
          style={{ textAlign: 'right' }}
          field="createdByName"
          header="נוצר ע״י"
          sortable
        />
        <Column
          style={{ textAlign: 'right' }}
          field="createdAt"
          header="נוצר בתאריך"
          sortable
          body={(rowData) =>
            rowData.createdAt
              ? dateFormat.displayFormatDate(new Date(rowData.createdAt))
              : ''
          }
        />
        <Column
          style={{ textAlign: 'right' }}
          field="פעולות"
          header=""
          body={(data: SettingsCheckStatusPaymentServiceEntity) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Button
                icon="pi pi-trash"
                text
                severity="danger"
                tooltip={'מחיקת שרות'}
                loading={deleteCheckId === data.id}
                disabled={deleteCheckId !== null}
                onClick={() => handleDeleteCheckPayment(data.id)}
              />
            </div>
          )}
        />
      </DataTable>

      <Dialog
        header="הוספת שרות להמחאה חוזרת"
        visible={showDialog}
        onHide={dialogHide}
        style={{
          width: '900px',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
      >
        <DialogAddCheckPaymentService closeDialog={dialogHide} />
      </Dialog>
    </div>
  );
});
